/* amazon-zoom.js — Horizon Theme */

/* ═══════════════════════════════════════════════
   AMAZON HOVER ZOOM
   ═══════════════════════════════════════════════ */

function getHighResUrl(img) {
  if (!img) return '';
  const maxRes = img.getAttribute('data-max-resolution');
  if (maxRes) {
    // Extract base Shopify filename to check if maxRes is stale
    const getBaseName = (url) => {
      if (!url) return '';
      const match = url.split('/').pop().split('?')[0].match(/^([a-zA-Z0-9\-_]+?)(?:_\d+x|_crop|_small|_medium|_large|_master)?(?:\.\w+)?$/);
      return match ? match[1] : url;
    };
    if (getBaseName(img.src) === getBaseName(maxRes)) {
      return maxRes;
    }
  }

  if (img.srcset) {
    const sources = img.srcset.split(',').map(s => {
      const parts = s.trim().split(' ');
      return { url: parts[0], width: parseInt(parts[1]) || 0 };
    });
    if (sources.length > 0) {
      sources.sort((a, b) => b.width - a.width);
      return sources[0].url;
    }
  }
  return img.src;
}

function initAmazonZoom() {
  const isDesktop = window.innerWidth >= 750;
  if (!isDesktop) return;

  const images = document.querySelectorAll('.image-amazon-zoom');
  images.forEach(imgTag => {
    // Skip zoom inside quick-add modal
    if (imgTag.closest('#quick-add-dialog, .quick-add-modal, #quick-add-modal-content')) return;

    if (imgTag.dataset.amazonZoomInit) return;
    imgTag.dataset.amazonZoomInit = 'true';

    imgTag.addEventListener('mouseenter', function(e) {
      const img = this;

      // STRICT VISIBILITY CHECK: Skip hidden/inactive slides of other variants
      const isVisible = img.offsetWidth > 0 && img.offsetHeight > 0 && window.getComputedStyle(img).opacity !== '0';
      if (!isVisible) return;

      const container = img.closest('.product-media');
      if (!container) return;

      // CLEANUP PREVIOUS LEFTOVERS: Guarantee zero stacking of duplicated elements
      document.querySelectorAll('.amazon-zoom-lens').forEach(el => el.remove());
      document.querySelectorAll('.amazon-zoom-window').forEach(el => el.remove());
      const oldProductDetails = document.querySelector('.product-details');
      if (oldProductDetails) oldProductDetails.classList.remove('is-zooming');

      // Create Lens
      const lens = document.createElement('div');
      lens.className = 'amazon-zoom-lens';
      container.appendChild(lens);

      // Create Zoom Window
      const zoomWindow = document.createElement('div');
      zoomWindow.className = 'amazon-zoom-window';
      const highResUrl = getHighResUrl(img);
      zoomWindow.style.backgroundImage = `url(${highResUrl})`;

      const zoomLevel = 2.5;

      // Append zoom window to product details panel
      const productDetails = document.querySelector('.product-details');
      if (productDetails) {
        productDetails.appendChild(zoomWindow);
        productDetails.classList.add('is-zooming');
      }

      const updateDimensions = () => {
        const imgW = img.clientWidth;
        const imgH = img.clientHeight;
        if (imgW === 0 || imgH === 0) return;

        // Sticky alignment: Position zoom window Y-coord exactly to match the sticky media gallery
        if (productDetails && container) {
          const containerRect = container.getBoundingClientRect();
          const detailsRect = productDetails.getBoundingClientRect();
          const offsetTop = containerRect.top - detailsRect.top;
          zoomWindow.style.top = offsetTop + 'px';
          zoomWindow.style.height = containerRect.height + 'px';
        } else {
          zoomWindow.style.height = imgH + 'px';
        }

        const lensW = zoomWindow.offsetWidth / zoomLevel;
        const lensH = zoomWindow.offsetHeight / zoomLevel;
        lens.style.width = lensW + 'px';
        lens.style.height = lensH + 'px';
        return { imgW, imgH, lensW, lensH };
      };

      let dims = updateDimensions();

      const moveLens = (e) => {
        if (!dims || dims.imgW === 0) dims = updateDimensions();
        if (!dims) return;

        const { imgW, imgH, lensW, lensH } = dims;
        const rect = img.getBoundingClientRect();
        let x = e.clientX - rect.left;
        let y = e.clientY - rect.top;

        // Constraint boundaries
        if (x < lensW / 2) x = lensW / 2;
        if (x > imgW - lensW / 2) x = imgW - lensW / 2;
        if (y < lensH / 2) y = lensH / 2;
        if (y > imgH - lensH / 2) y = imgH - lensH / 2;

        lens.style.left = (x - lensW / 2) + 'px';
        lens.style.top = (y - lensH / 2) + 'px';

        // Background mapping
        zoomWindow.style.backgroundSize = (imgW * zoomLevel) + 'px ' + (imgH * zoomLevel) + 'px';
        zoomWindow.style.backgroundPosition = '-' + ((x - lensW / 2) * zoomLevel) + 'px -' + ((y - lensH / 2) * zoomLevel) + 'px';
      };

      const handleScroll = () => {
        updateDimensions();
      };
      window.addEventListener('scroll', handleScroll, { passive: true });

      const removeZoom = () => {
        lens.remove();
        zoomWindow.remove();
        if (productDetails) productDetails.classList.remove('is-zooming');
        img.removeEventListener('mousemove', moveLens);
        img.removeEventListener('mouseleave', removeZoom);
        window.removeEventListener('scroll', handleScroll);
      };

      img.addEventListener('mousemove', moveLens);
      img.addEventListener('mouseleave', removeZoom);

      container.addEventListener('mouseleave', removeZoom, { once: true });
    });
  });
}

document.addEventListener('DOMContentLoaded', initAmazonZoom);
window.addEventListener('resize', initAmazonZoom);

// For dynamic variant switching or AJAX reload, listen to DOM changes
const observer = new MutationObserver(() => {
  initAmazonZoom();
  NykaaLightbox.init();
});
observer.observe(document.body, { childList: true, subtree: true });


/* ═══════════════════════════════════════════════
   NYKAA-STYLE LIGHTBOX
   ═══════════════════════════════════════════════ */

const NykaaLightbox = (() => {
  let lb = null;
  let productData = null;
  let mediaData = [];
  let currentIndex = 0;
  let activeTab = 'images'; // 'images' | 'videos'
  let touchStartX = 0;
  let touchStartY = 0;

  /* ── Mobile Pinch Zoom & Pan Variables ── */
  let currentScale = 1;
  let startX = 0;
  let startY = 0;
  let translateX = 0;
  let translateY = 0;
  let lastTranslateX = 0;
  let lastTranslateY = 0;
  let initialHypot = 0;
  let isPinching = false;
  let isDragging = false;
  let lastTapTime = 0;

  /* ── Selectors ── */
  const $ = (id) => document.getElementById(id);

  /* ── Get currently selected variant ID on the page ── */
  function getSelectedVariantId() {
    const variantIdInput = document.querySelector('form[id^="BuyButtons-ProductForm-"] input[name="id"]') ||
                           document.querySelector('form[action*="/cart/add"] input[name="id"]') ||
                           document.querySelector('input[name="id"]');
    return variantIdInput ? parseInt(variantIdInput.value) : null;
  }

  /* ── Sync lightbox UI with active variant price, compare price, discount, and stock state ── */
  function syncSelectedVariantState() {
    if (!productData || !productData.variants) return;

    const variantId = getSelectedVariantId();
    if (!variantId) return;

    const variant = productData.variants.find(v => v.id === variantId);
    if (!variant) return;

    // Update Price
    const priceEl = $('nykaa-lb-price');
    if (priceEl) priceEl.textContent = variant.price;

    // Update Compare Price
    let compareEl = lb.querySelector('.nykaa-lb__compare-price');
    const priceContainer = lb.querySelector('.nykaa-lb__product-price');
    
    if (compareEl) {
      compareEl.remove();
      compareEl = null;
    }

    if (variant.compare_price && parseFloat(variant.compare_price.replace(/[^0-9.]/g, '')) > parseFloat(variant.price.replace(/[^0-9.]/g, ''))) {
      compareEl = document.createElement('span');
      compareEl.className = 'nykaa-lb__compare-price';
      compareEl.textContent = variant.compare_price;
      if (priceEl && priceContainer) {
        priceEl.after(compareEl);
      }
    }

    // Update Discount Badge
    let discountEl = lb.querySelector('.nykaa-lb__discount-badge');
    if (discountEl) {
      discountEl.remove();
      discountEl = null;
    }

    if (variant.discount_percent > 0) {
      discountEl = document.createElement('span');
      discountEl.className = 'nykaa-lb__discount-badge';
      discountEl.innerHTML = `
        <svg class="nykaa-lb__discount-svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
          <line x1="12" y1="5" x2="12" y2="19"></line>
          <polyline points="19 12 12 19 5 12"></polyline>
        </svg>
        ${variant.discount_percent}%
      `;
      if (priceContainer) {
        priceContainer.prepend(discountEl);
      }
    }

    // Update Sold Out Badge next to price
    let soldOutBadge = lb.querySelector('.nykaa-lb__sold-out-badge');
    if (soldOutBadge) {
      soldOutBadge.remove();
    }
    if (!variant.available) {
      soldOutBadge = document.createElement('span');
      soldOutBadge.className = 'nykaa-lb__sold-out-badge';
      soldOutBadge.textContent = 'Sold Out';
      if (priceContainer) {
        priceContainer.appendChild(soldOutBadge);
      }
    }

    // Update Add to Cart Button state
    const lbAddBag = $('nykaa-lb-add-bag');
    if (lbAddBag) {
      if (variant.available) {
        lbAddBag.textContent = 'Add to Cart';
        lbAddBag.className = 'nykaa-lb__add-bag-btn';
        lbAddBag.removeAttribute('disabled');
        lbAddBag.removeAttribute('aria-disabled');
      } else {
        lbAddBag.textContent = 'Sold Out';
        lbAddBag.className = 'nykaa-lb__add-bag-btn nykaa-lb__add-bag-btn--soldout';
        lbAddBag.setAttribute('disabled', 'true');
        lbAddBag.setAttribute('aria-disabled', 'true');
      }
    }
  }

  /* ── Open lightbox at given media index ── */
  function open(startIndex = 0) {
    lb = $('nykaa-lightbox');
    if (!lb) return;

    // Move lightbox to body to ensure it is on top of sticky header, product details, and all other elements
    if (lb.parentElement !== document.body) {
      document.body.appendChild(lb);
    }

    loadData();
    if (!mediaData.length) return;

    // Sync state of currently selected variant (availability, prices, discount etc.)
    syncSelectedVariantState();

    currentIndex = startIndex;
    const startItem = mediaData[startIndex];
    const startIsVideo = startItem && (startItem.type === 'video' || startItem.type === 'external_video');
    activeTab = startIsVideo ? 'videos' : 'images';

    // Build slides
    buildSlides();
    // Build thumbnails
    buildThumbs();
    // Show/hide Videos tab based on whether product has videos
    updateTabVisibility();
    // Activate first tab
    activateTab(activeTab);
    // Show current media
    renderMedia(currentIndex);

    lb.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';

    // Bind keyboard
    document.addEventListener('keydown', handleKeyDown);
  }

  /* ── Show/hide Videos tab based on available media ── */
  function updateTabVisibility() {
    const hasVideos = mediaData.some(m =>
      m.type === 'video' || m.type === 'external_video'
    );

    // Target all Videos tab buttons (desktop + mobile)
    document.querySelectorAll('.nykaa-lb__tab[data-tab="videos"]').forEach(btn => {
      btn.style.display = hasVideos ? '' : 'none';
    });

    // If no videos, ensure Images tab is active and looks correct
    if (!hasVideos) {
      document.querySelectorAll('.nykaa-lb__tab[data-tab="images"]').forEach(btn => {
        btn.classList.add('nykaa-lb__tab--active');
        btn.setAttribute('aria-selected', 'true');
      });
    }
  }

  /* ── Close lightbox ── */
  function close() {
    lb = $('nykaa-lightbox');
    if (!lb) return;
    lb.setAttribute('hidden', '');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', handleKeyDown);

    // Pause any playing video
    document.querySelectorAll('.nykaa-lb__slide-video').forEach(vid => {
      vid.pause();
    });
    document.querySelectorAll('.nykaa-lb__slide-ext-video').forEach(extVid => {
      extVid.innerHTML = '';
    });
  }

  /* ── Load product JSON data ── */
  function loadData() {
    const dataEl = document.getElementById('nykaa-lightbox-data');
    if (!dataEl) return;
    try {
      const parsed = JSON.parse(dataEl.textContent);
      productData = parsed;
      mediaData = parsed.media || [];
    } catch (e) {
      console.warn('[NykaaLightbox] Could not parse product data.', e);
    }
  }

  /* ── Build slider slides ── */
  function buildSlides() {
    const track = $('nykaa-lb-slider-track');
    if (!track) return;

    track.innerHTML = '';

    mediaData.forEach((item, i) => {
      const slide = document.createElement('div');
      slide.className = 'nykaa-lb__slide';
      slide.setAttribute('data-index', i);
      slide.setAttribute('data-media-type', item.type);

      const isVideo = item.type === 'video';
      const isExternal = item.type === 'external_video';
      const isImage = !isVideo && !isExternal;

      if (isImage) {
        const img = document.createElement('img');
        img.className = 'nykaa-lb__slide-img';
        img.src = item.src_large || item.src;
        img.alt = item.alt || '';
        img.loading = 'lazy';
        slide.appendChild(img);
      } else if (isVideo) {
        const vid = document.createElement('video');
        vid.className = 'nykaa-lb__slide-video';
        vid.controls = true;
        vid.playsInline = true;
        vid.preload = 'auto';

        if (item.video_sources && item.video_sources.length) {
          const mp4Sources = item.video_sources.filter(s =>
            s.mime_type === 'video/mp4' || (s.url && s.url.includes('.mp4'))
          );
          const hlsSources = item.video_sources.filter(s =>
            s.mime_type === 'application/x-mpegURL' ||
            s.mime_type === 'application/vnd.apple.mpegurl' ||
            (s.url && s.url.includes('.m3u8'))
          );
          const preferred = mp4Sources.length ? mp4Sources : hlsSources;
          const fallback  = mp4Sources.length ? hlsSources  : [];

          preferred.forEach(src => {
            const s = document.createElement('source');
            s.src = src.url;
            s.type = src.mime_type;
            vid.appendChild(s);
          });
          fallback.forEach(src => {
            const s = document.createElement('source');
            s.src = src.url;
            s.type = src.mime_type;
            vid.appendChild(s);
          });
          if (preferred.length) {
            vid.src = preferred[0].url;
          }
        }
        slide.appendChild(vid);
      } else if (isExternal) {
        const extContainer = document.createElement('div');
        extContainer.className = 'nykaa-lb__slide-ext-video';
        slide.appendChild(extContainer);
      }

      track.appendChild(slide);
    });
  }

  /* ── Build thumbnail items ── */
  function buildThumbs() {
    const grid = $('nykaa-lb-thumb-grid');
    const strip = $('nykaa-lb-thumb-strip');
    if (!grid || !strip) return;

    grid.innerHTML = '';
    strip.innerHTML = '';

    mediaData.forEach((item, i) => {
      const isVideo = item.type === 'video' || item.type === 'external_video';

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'nykaa-lb__thumb' + (isVideo ? ' nykaa-lb__thumb--video' : '');
      btn.setAttribute('data-index', i);
      btn.setAttribute('data-media-type', item.type);
      btn.setAttribute('aria-label', item.alt || ('Media ' + (i + 1)));
      btn.setAttribute('role', 'listitem');

      const img = document.createElement('img');
      img.src = item.src;
      img.alt = item.alt || '';
      img.loading = 'lazy';
      btn.appendChild(img);

      btn.addEventListener('click', () => {
        currentIndex = i;
        renderMedia(i);
      });

      // Clone for strip
      const btnClone = btn.cloneNode(true);
      btnClone.addEventListener('click', () => {
        currentIndex = i;
        renderMedia(i);
      });

      grid.appendChild(btn);
      strip.appendChild(btnClone);
    });
  }

  /* ── Activate tab (images / videos) ── */
  function activateTab(tab) {
    activeTab = tab;

    // Update all tab buttons (both mobile-header and desktop-tabs sets)
    document.querySelectorAll('.nykaa-lb__tab').forEach(btn => {
      const isActive = btn.getAttribute('data-tab') === tab;
      btn.classList.toggle('nykaa-lb__tab--active', isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    // Filter thumbnails in grid and strip
    document.querySelectorAll('.nykaa-lb__thumb').forEach(btn => {
      const mediaType = btn.getAttribute('data-media-type');
      const isVideo = mediaType === 'video' || mediaType === 'external_video';
      const show = tab === 'images' ? !isVideo : isVideo;
      btn.classList.toggle('nykaa-lb__item--hidden', !show);
    });

    // Filter slides in track
    document.querySelectorAll('.nykaa-lb__slide').forEach(slide => {
      const mediaType = slide.getAttribute('data-media-type');
      const isVideo = mediaType === 'video' || mediaType === 'external_video';
      const show = tab === 'images' ? !isVideo : isVideo;
      slide.style.display = show ? 'flex' : 'none';
    });

    // If current index doesn't match tab, jump to first matching item
    const currentItem = mediaData[currentIndex];
    if (currentItem) {
      const currentIsVideo = currentItem.type === 'video' || currentItem.type === 'external_video';
      const mismatch = tab === 'images' ? currentIsVideo : !currentIsVideo;
      if (mismatch) {
        const firstMatch = mediaData.findIndex((m, i) => {
          const iv = m.type === 'video' || m.type === 'external_video';
          return tab === 'images' ? !iv : iv;
        });
        if (firstMatch !== -1) {
          currentIndex = firstMatch;
          renderMedia(currentIndex);
          return;
        }
      }
    }

    updateNavArrows();
  }

  /* ── Render main media at index ── */
  function renderMedia(index) {
    const item = mediaData[index];
    if (!item) return;

    // Reset zoom state on new render
    resetZoom();

    currentIndex = index;

    // Translate track
    const track = $('nykaa-lb-slider-track');
    if (track) {
      track.style.transition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
      const slides = Array.from(track.querySelectorAll('.nykaa-lb__slide'));
      const visibleSlides = slides.filter(slide => slide.style.display !== 'none');
      const activeSlide = track.querySelector(`.nykaa-lb__slide[data-index="${index}"]`);
      const visibleIndex = visibleSlides.indexOf(activeSlide);
      if (visibleIndex !== -1) {
        track.style.transform = `translateX(-${visibleIndex * 100}%)`;
      } else {
        track.style.transform = `translateX(-${currentIndex * 100}%)`;
      }
    }

    // Play/pause videos
    if (track) {
      document.querySelectorAll('.nykaa-lb__slide-video').forEach(vid => {
        vid.pause();
      });
      document.querySelectorAll('.nykaa-lb__slide-ext-video').forEach(extVid => {
        extVid.innerHTML = '';
      });

      const activeSlide = track.querySelector(`.nykaa-lb__slide[data-index="${index}"]`);
      if (activeSlide) {
        const isVideo = item.type === 'video';
        const isExternal = item.type === 'external_video';
        const isImage = !isVideo && !isExternal;

        if (isImage) {
          setupMobileZoom();
        } else if (isVideo) {
          const vid = activeSlide.querySelector('.nykaa-lb__slide-video');
          if (vid) {
            vid.muted = false;
            vid.play().catch(() => {
              vid.muted = true;
              vid.play().catch(() => {});
            });
          }
        } else if (isExternal) {
          const extVid = activeSlide.querySelector('.nykaa-lb__slide-ext-video');
          if (extVid) {
            if (item.host === 'youtube') {
              extVid.innerHTML = `<iframe src="https://www.youtube.com/embed/${item.external_id}?autoplay=1&rel=0" allow="autoplay; encrypted-media" allowfullscreen></iframe>`;
            } else if (item.host === 'vimeo') {
              extVid.innerHTML = `<iframe src="https://player.vimeo.com/video/${item.external_id}?autoplay=1" allow="autoplay; encrypted-media" allowfullscreen></iframe>`;
            }
          }
        }
      }
    }

    // Update active thumbnail
    updateActiveThumbs(index);
    updateNavArrows();

    // Scroll active thumb into view (in both grid and strip)
    setTimeout(() => {
      document.querySelectorAll(`.nykaa-lb__thumb[data-index="${index}"]`).forEach(btn => {
        btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      });
    }, 50);
  }

  /* ── Mark active thumbnail ── */
  function updateActiveThumbs(index) {
    document.querySelectorAll('.nykaa-lb__thumb').forEach(btn => {
      btn.classList.toggle('nykaa-lb__thumb--active', parseInt(btn.getAttribute('data-index')) === index);
    });
  }

  /* ── Show/hide prev/next nav arrows ── */
  function updateNavArrows() {
    const prev = $('nykaa-lb-prev');
    const next = $('nykaa-lb-next');
    if (!prev || !next) return;

    // Get visible items for active tab
    const visibleIndices = mediaData.reduce((acc, m, i) => {
      const iv = m.type === 'video' || m.type === 'external_video';
      if (activeTab === 'images' ? !iv : iv) acc.push(i);
      return acc;
    }, []);

    const pos = visibleIndices.indexOf(currentIndex);
    prev.toggleAttribute('hidden', pos <= 0);
    next.toggleAttribute('hidden', pos >= visibleIndices.length - 1);
  }

  /* ── Navigate prev/next within visible tab items ── */
  function navigate(direction) {
    const visibleIndices = mediaData.reduce((acc, m, i) => {
      const iv = m.type === 'video' || m.type === 'external_video';
      if (activeTab === 'images' ? !iv : iv) acc.push(i);
      return acc;
    }, []);

    const pos = visibleIndices.indexOf(currentIndex);
    const newPos = pos + direction;
    if (newPos < 0 || newPos >= visibleIndices.length) {
      renderMedia(currentIndex);
      return;
    }
    currentIndex = visibleIndices[newPos];
    renderMedia(currentIndex);
  }

  /* ── Keyboard handler ── */
  function handleKeyDown(e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { navigate(-1); return; }
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { navigate(1); return; }
  }

  /* ── Touch / swipe support ── */
  function onTouchStart(e) {
    if (e.touches && e.touches.length > 1) {
      isSwiping = false;
      return;
    }
    if (currentScale > 1.05) return;

    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
    isSwiping = true;
    swipeDeltaX = 0;

    const track = $('nykaa-lb-slider-track');
    if (track) {
      track.style.transition = 'none';
    }
  }

  function onTouchMove(e) {
    if (e.touches && e.touches.length > 1) {
      isSwiping = false;
      return;
    }
    if (!isSwiping) return;
    if (currentScale > 1.05) return;

    const currentX = e.touches[0].clientX;
    const currentY = e.touches[0].clientY;
    swipeDeltaX = currentX - touchStartX;
    const deltaY = currentY - touchStartY;

    if (Math.abs(deltaY) > Math.abs(swipeDeltaX)) {
      return;
    }

    e.preventDefault();

    const track = $('nykaa-lb-slider-track');
    if (track) {
      const trackWidth = track.clientWidth;
      const slides = Array.from(track.querySelectorAll('.nykaa-lb__slide'));
      const visibleSlides = slides.filter(slide => slide.style.display !== 'none');
      const activeSlide = track.querySelector(`.nykaa-lb__slide[data-index="${currentIndex}"]`);
      const visibleIndex = visibleSlides.indexOf(activeSlide) !== -1 ? visibleSlides.indexOf(activeSlide) : currentIndex;
      const baseOffset = -visibleIndex * trackWidth;
      
      let offset = baseOffset + swipeDeltaX;
      if (visibleIndex === 0 && swipeDeltaX > 0) {
        offset = baseOffset + swipeDeltaX * 0.35;
      } else if (visibleIndex === visibleSlides.length - 1 && swipeDeltaX < 0) {
        offset = baseOffset + swipeDeltaX * 0.35;
      }

      track.style.transform = `translateX(${offset}px)`;
    }
  }

  function onTouchEnd(e) {
    if (!isSwiping) return;
    isSwiping = false;

    const track = $('nykaa-lb-slider-track');
    if (!track) return;

    track.style.transition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';

    const threshold = track.clientWidth * 0.15;
    if (swipeDeltaX > threshold) {
      navigate(-1);
    } else if (swipeDeltaX < -threshold) {
      navigate(1);
    } else {
      renderMedia(currentIndex);
    }
  }

  /* ── Mobile pinch zoom & pan handlers ── */
  function resetZoom() {
    currentScale = 1;
    translateX = 0;
    translateY = 0;
    lastTranslateX = 0;
    lastTranslateY = 0;
    isPinching = false;
    isDragging = false;
    const track = $('nykaa-lb-slider-track');
    if (track) {
      const activeSlide = track.querySelector(`.nykaa-lb__slide[data-index="${currentIndex}"]`);
      const mainImg = activeSlide ? activeSlide.querySelector('.nykaa-lb__slide-img') : null;
      if (mainImg) {
        mainImg.style.transform = 'none';
        mainImg.style.transition = 'transform 0.2s ease';
      }
    }
  }

  function setupMobileZoom() {
    const track = $('nykaa-lb-slider-track');
    if (!track) return;
    const activeSlide = track.querySelector(`.nykaa-lb__slide[data-index="${currentIndex}"]`);
    const mainImg = activeSlide ? activeSlide.querySelector('.nykaa-lb__slide-img') : null;
    if (!mainImg) return;

    if (mainImg.dataset.zoomEventsWired === 'true') return;
    mainImg.dataset.zoomEventsWired = 'true';

    mainImg.addEventListener('touchstart', (e) => {
      mainImg.style.transition = 'none';

      if (e.touches.length === 2) {
        e.preventDefault();
        isPinching = true;
        isDragging = false;
        initialHypot = Math.hypot(
          e.touches[0].clientX - e.touches[1].clientX,
          e.touches[0].clientY - e.touches[1].clientY
        );
      } else if (e.touches.length === 1) {
        const now = Date.now();
        const isDoubleTap = (now - lastTapTime < 300);
        lastTapTime = now;

        if (isDoubleTap) {
          e.preventDefault();
          if (currentScale > 1.05) {
            resetZoom();
          } else {
            currentScale = 2.5;
            translateX = 0;
            translateY = 0;
            lastTranslateX = 0;
            lastTranslateY = 0;
            applyTransform(true);
          }
          lastTapTime = 0;
          isDragging = false;
        } else {
          if (currentScale > 1.05) {
            isDragging = true;
            isPinching = false;
            startX = e.touches[0].clientX - lastTranslateX;
            startY = e.touches[0].clientY - lastTranslateY;
          }
        }
      }
    }, { passive: false });

    mainImg.addEventListener('touchmove', (e) => {
      if (isPinching && e.touches.length === 2) {
        e.preventDefault();
        const currentHypot = Math.hypot(
          e.touches[0].clientX - e.touches[1].clientX,
          e.touches[0].clientY - e.touches[1].clientY
        );
        const scaleChange = currentHypot / initialHypot;
        currentScale = Math.min(Math.max(scaleChange * currentScale, 1), 4);
        initialHypot = currentHypot;
        applyTransform(false);
      } else if (isDragging && e.touches.length === 1 && currentScale > 1.05) {
        e.preventDefault();
        translateX = e.touches[0].clientX - startX;
        translateY = e.touches[0].clientY - startY;

        const limitX = (currentScale - 1) * (mainImg.clientWidth / 2);
        const limitY = (currentScale - 1) * (mainImg.clientHeight / 2);
        translateX = Math.min(Math.max(translateX, -limitX), limitX);
        translateY = Math.min(Math.max(translateY, -limitY), limitY);

        applyTransform(false);
      }
    }, { passive: false });

    mainImg.addEventListener('touchend', (e) => {
      isPinching = false;
      isDragging = false;
      lastTranslateX = translateX;
      lastTranslateY = translateY;

      if (currentScale < 1.05) {
        resetZoom();
      }
    });

    function applyTransform(withTransition = false) {
      if (withTransition) {
        mainImg.style.transition = 'transform 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
      } else {
        mainImg.style.transition = 'none';
      }
      mainImg.style.transform = `translate(${translateX}px, ${translateY}px) scale(${currentScale})`;
    }
  }

  /* ── Init: attach click listeners to product images ── */
  function init() {
    lb = $('nykaa-lightbox');
    if (lb && lb.parentElement !== document.body) {
      document.body.appendChild(lb);
    }

    if (!window.nykaaDelegatedInit) {
      window.nykaaDelegatedInit = true;
      document.addEventListener('click', (e) => {
        const img = e.target.closest('.image-amazon-zoom');
        if (!img) return;

        // Skip zoom lightbox inside quick-add modal
        if (img.closest('#quick-add-dialog, .quick-add-modal, #quick-add-modal-content')) return;

        e.preventDefault();
        e.stopPropagation();

        const container = img.closest('[data-media-id]');
        const mediaId = container ? container.getAttribute('data-media-id') : null;
        loadData();

        let startIndex = 0;
        if (mediaId) {
          const found = mediaData.findIndex(m => String(m.id) === String(mediaId));
          if (found !== -1) startIndex = found;
        }

        open(startIndex);
      });
    }

    bindLightboxEvents();
  }

  /* ── Bind all UI events inside the lightbox ── */
  function bindLightboxEvents() {
    const lightbox = $('nykaa-lightbox');
    if (!lightbox) return;
    if (lightbox.dataset.eventsWired === 'true') return;
    lightbox.dataset.eventsWired = 'true';

    // Overlay click → close
    const overlay = $('nykaa-lb-overlay');
    if (overlay) overlay.addEventListener('click', close);

    // Close buttons
    [$('nykaa-lb-close-desktop'), $('nykaa-lb-close-mobile')].forEach(btn => {
      if (btn) btn.addEventListener('click', close);
    });

    // Prev / Next
    const prevBtn = $('nykaa-lb-prev');
    const nextBtn = $('nykaa-lb-next');
    if (prevBtn) prevBtn.addEventListener('click', () => navigate(-1));
    if (nextBtn) nextBtn.addEventListener('click', () => navigate(1));

    // Tabs — all tab buttons (desktop + mobile)
    lightbox.addEventListener('click', (e) => {
      const tabBtn = e.target.closest('.nykaa-lb__tab');
      if (!tabBtn) return;
      const tab = tabBtn.getAttribute('data-tab');
      if (tab) activateTab(tab);
    });

    // Add to Cart button click handler
    const lbAddBag = $('nykaa-lb-add-bag');
    if (lbAddBag) {
      lbAddBag.addEventListener('click', (e) => {
        e.preventDefault();

        const mainBtn = document.querySelector('form[id^="BuyButtons-ProductForm-"] button[name="add"]') || 
                        document.querySelector('product-form-component button[name="add"]') ||
                        document.querySelector('form[action*="/cart/add"] button[name="add"]') ||
                        document.querySelector('button[name="add"]');
        if (mainBtn) {
          close();
          mainBtn.click();
        } else {
          console.warn('[NykaaLightbox] Main Add to Cart button not found.');
        }
      });
    }

    // Touch swipe on main image area
    const imgWrap = lightbox.querySelector('.nykaa-lb__main-img-wrap');
    if (imgWrap) {
      imgWrap.addEventListener('touchstart', onTouchStart, { passive: false });
      imgWrap.addEventListener('touchmove', onTouchMove, { passive: false });
      imgWrap.addEventListener('touchend', onTouchEnd, { passive: false });
    }
  }

  /* ── Public API ── */
  return { init, open, close };
})();

document.addEventListener('DOMContentLoaded', () => {
  initAmazonZoom();
  NykaaLightbox.init();
});
window.addEventListener('resize', initAmazonZoom);

// Re-initialize Amazon Zoom on variant changes
document.addEventListener('variant:update', () => {
  setTimeout(() => {
    initAmazonZoom();
  }, 120);
});

document.addEventListener('variant:images:changed', () => {
  setTimeout(() => {
    initAmazonZoom();
  }, 120);
});


